import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearchTaiKhoanIcloud } from "../../../actions/QuanTriHeThong";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { DanhSachBankConst } from "../../../constants/danhSachTaiSanConst";

export const SearchBarDesktop = ({ onSearch }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanIcloud);

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateState = (field, text) => {
    dispatch(
      updateDataSearchTaiKhoanIcloud({
        ...dataSearch,
        [field]: text,
      })
    );
  };
  const updateDropdown = (field) => (e) => {
    updateState(field, e.target.value);
  };
  const SoHDLienKet = {
    lstSoHDLienKet: [
      {
        label: "Số HĐ liên kết",
        value: "-1",
      },
      { label: "0", value: "0" },
      { label: "1", value: "1" },
      { label: "2", value: "2" },
      { label: "3", value: "3" },
      { label: "4", value: "4" },
      { label: "5", value: "5" },
      { label: ">5", value: "6" },
    ],
  };
  const TrangThaiTaiKhoan = {
    lstTrangThai: [
      {
        label: "Trạng thái",
        value: "-1",
      },
      { label: "Bình thường", value: "0" },
      { label: "Hạn chế", value: "1" },
    ],
  };
  const TrangThaiKhoa = {
    lstTrangThai: [
      {
        label: "Trạng thái",
        value: "-1",
      },
      { label: "Đang khóa", value: "1" },
      { label: "Đang mở", value: "0" },
    ],
  };
  useEffect(() => {}, []);
  return (
    <>
      <div
        className="search-new hidden-mobile-main show-table-main"
        style={{ marginTop: 10 }}
      >
        <div className="input-sm-new input-new-12">
          <input
            placeholder="Tên tài khoản "
            type="text"
            className="form-control input-sm"
            value={dataSearch.TenTaiKhoan}
            onChange={updateTextValue("TenTaiKhoan")}
          ></input>
        </div>
        <div className="input-sm-new input-new-12">
          <input
            placeholder="Số điện thoại "
            type="text"
            className="form-control input-sm"
            value={dataSearch.SoDienThoai}
            onChange={updateTextValue("SoDienThoai")}
          ></input>
        </div>
        <div className="input-sm-new input-new-12">
          <select
            name="loaigiaodich"
            className="selectBox form-control input-sm"
            value={dataSearch.SoHDLienKet}
            onChange={updateDropdown("SoHDLienKet")}
          >
            {SoHDLienKet.lstSoHDLienKet &&
              SoHDLienKet.lstSoHDLienKet.map((item, idx) => (
                <option key={"objComboStore1" + idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>
        <div className="input-sm-new input-new-12">
          <select
            name="loaigiaodich"
            className="selectBox form-control input-sm"
            value={dataSearch.iHanChe}
            onChange={updateDropdown("iHanChe")}
          >
            {TrangThaiTaiKhoan.lstTrangThai &&
              TrangThaiTaiKhoan.lstTrangThai.map((item, idx) => (
                <option key={"objComboStore1" + idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>
        <div className="input-sm-new input-new-12">
          <select
            name="loaigiaodich"
            className="selectBox form-control input-sm"
            value={dataSearch.iLock}
            onChange={updateDropdown("iLock")}
          >
            {TrangThaiKhoa.lstTrangThai &&
              TrangThaiKhoa.lstTrangThai.map((item, idx) => (
                <option key={"objComboStore1" + idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>
        <div className="input-sm-new input-new-18 search-main-new">
          <button
            type="submit"
            className="btn btn-info-new "
            onClick={onSearch}
          >
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
